export default "__VITE_ASSET__$FIuvn5J__"